/* ===== CURSOR ===== */
const ring = document.getElementById('cursor-ring');
const dot = document.getElementById('cursor-dot');
let mouseX = -100, mouseY = -100, ringX = -100, ringY = -100;

document.addEventListener('mousemove', (e) => {
  mouseX = e.clientX; mouseY = e.clientY;
  dot.style.left = mouseX + 'px';
  dot.style.top = mouseY + 'px';
});

function animateCursor() {
  ringX += (mouseX - ringX) * 0.12;
  ringY += (mouseY - ringY) * 0.12;
  ring.style.left = ringX + 'px';
  ring.style.top = ringY + 'px';
  requestAnimationFrame(animateCursor);
}
animateCursor();

document.querySelectorAll('a, button, [data-hover]').forEach(el => {
  el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
  el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
});

/* ===== NAV ===== */
const nav = document.querySelector('.nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', window.scrollY > 40);
});

const hamburger = document.querySelector('.nav__hamburger');
const mobileNav = document.querySelector('.mobile-nav');
if (hamburger && mobileNav) {
  hamburger.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
    const spans = hamburger.querySelectorAll('span');
    if (mobileNav.classList.contains('open')) {
      spans[0].style.transform = 'rotate(45deg) translate(4px, 4px)';
      spans[1].style.opacity = '0';
      spans[2].style.transform = 'rotate(-45deg) translate(4px, -4px)';
    } else {
      spans.forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
    }
  });
}

/* ===== HERO ANIMATION ===== */
function initHero() {
  const eyebrow = document.querySelector('.hero__eyebrow');
  const words = document.querySelectorAll('.hero__headline span');
  const sub = document.querySelector('.hero__sub');
  const ctas = document.querySelector('.hero__ctas');
  const scroll = document.querySelector('.hero__scroll');

  if (!eyebrow) return;

  const delay = (ms) => new Promise(r => setTimeout(r, ms));

  async function animate() {
    await delay(300);
    eyebrow.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    eyebrow.style.opacity = '1'; eyebrow.style.transform = 'none';

    for (let i = 0; i < words.length; i++) {
      await delay(i === 0 ? 200 : 120);
      words[i].style.transition = `opacity 0.9s cubic-bezier(0.22,1,0.36,1), transform 0.9s cubic-bezier(0.22,1,0.36,1)`;
      words[i].style.opacity = '1'; words[i].style.transform = 'none';
    }
    await delay(200);
    [sub, ctas, scroll].forEach(el => {
      if (!el) return;
      el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      el.style.opacity = '1'; el.style.transform = 'none';
    });
  }
  animate();
}
document.addEventListener('DOMContentLoaded', initHero);

/* ===== SCROLL REVEAL ===== */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ===== CART ===== */
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function renderCart() {
  const cart = await fetchCart();
  const container = document.getElementById('cart-drawer__items');
  const totalEl = document.getElementById('cart-total');
  updateCartCount(cart.item_count);

  if (cart.item_count === 0) {
    container.innerHTML = '<div style="text-align:center;padding:48px 0;color:#9ca3af;font-size:13px;">Your cart is empty.</div>';
    totalEl.textContent = '£0.00';
    return;
  }

  totalEl.textContent = '£' + (cart.total_price / 100).toFixed(2);
  container.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item__img" src="${item.image}" alt="${item.title}">
      <div class="cart-item__info">
        <div>
          <p class="cart-item__name">${item.product_title}</p>
          <p class="cart-item__price">£${(item.price / 100).toFixed(2)}</p>
        </div>
        <div class="cart-item__controls">
          <div class="qty-control">
            <button onclick="updateQty(${item.key}, ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateQty(${item.key}, ${item.quantity + 1})">+</button>
          </div>
          <button class="cart-item__remove" onclick="updateQty(${item.key}, 0)">Remove</button>
        </div>
      </div>
    </div>
  `).join('');
}

async function updateQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  renderCart();
}

async function addToCart(variantId, quantity = 1) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  openCart();
}

function updateCartCount(count) {
  document.querySelectorAll('.nav__cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
}

async function initCartCount() {
  const cart = await fetchCart();
  updateCartCount(cart.item_count);
}
document.addEventListener('DOMContentLoaded', initCartCount);

/* ===== PARALLAX HERO ===== */
window.addEventListener('scroll', () => {
  const heroContent = document.querySelector('.hero__content');
  if (!heroContent) return;
  const scrolled = window.scrollY;
  heroContent.style.transform = `translateY(${scrolled * 0.3}px)`;
  heroContent.style.opacity = Math.max(0, 1 - scrolled / (window.innerHeight * 0.6));
});
